var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInTransitSupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.772 16C15.2415 16 14.7328 16.2107 14.3578 16.5858C13.9827 16.9609 13.772 17.4696 13.772 18V29H15.772C15.772 29.7956 16.088 30.5587 16.6507 31.1213C17.2133 31.6839 17.9763 32 18.772 32C19.5676 32 20.3307 31.6839 20.8933 31.1213C21.4559 30.5587 21.772 29.7956 21.772 29H27.772C27.772 29.7956 28.088 30.5587 28.6507 31.1213C29.2133 31.6839 29.9763 32 30.772 32C31.5676 32 32.3307 31.6839 32.8933 31.1213C33.4559 30.5587 33.772 29.7956 33.772 29H35.772V24L32.772 20H29.772V16M22.772 18L26.772 22L22.772 26V23H16.772V21H22.772M29.772 21.5H32.272L34.242 24H29.772M18.772 27.5C19.1698 27.5 19.5513 27.658 19.8326 27.9393C20.1139 28.2206 20.272 28.6022 20.272 29C20.272 29.3978 20.1139 29.7794 19.8326 30.0607C19.5513 30.342 19.1698 30.5 18.772 30.5C18.3741 30.5 17.9926 30.342 17.7113 30.0607C17.43 29.7794 17.272 29.3978 17.272 29C17.272 28.6022 17.43 28.2206 17.7113 27.9393C17.9926 27.658 18.3741 27.5 18.772 27.5ZM30.772 27.5C31.1698 27.5 31.5513 27.658 31.8326 27.9393C32.1139 28.2206 32.272 28.6022 32.272 29C32.272 29.3978 32.1139 29.7794 31.8326 30.0607C31.5513 30.342 31.1698 30.5 30.772 30.5C30.3741 30.5 29.9926 30.342 29.7113 30.0607C29.43 29.7794 29.272 29.3978 29.272 29C29.272 28.6022 29.43 28.2206 29.7113 27.9393C29.9926 27.658 30.3741 27.5 30.772 27.5Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransitSupplyReqIcon);
export default __webpack_public_path__ + "static/media/in-transit-supply-req-icon.cf70d1229d3e2e0ba22744b7ce308f07.svg";
export { ForwardRef as ReactComponent };